/**
 * created by lei lei
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TextBtn from "./TextBtn";
import OneClickBtn from "./OneClickBtn";
import {Button} from "antd";
export default class OneClickOpenFullButtonBtn extends OneClickBtn  {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    getBtn(){
        if(this.props.btn && this.props.btn.type === 'textBtn') {
            return(<TextBtn btnClick={()=>{
                this[this.props.btn&&this.props.btn.okFunctionName](this.props.record)
            }} btnText={this.props.btnText} />)
        } else {
            return (<Button style={{color: "#fff", background: "#0050B3"}} onClick={()=>{
                this[this.props.btn&&this.props.btn.okFunctionName](this.props.record)
            }} >{this.props.btnText}</Button>)
        }
    }


   btnOpenFUll(record){


       /*let url=this.props.btn.requestUrl||'';
       let body={};
       let method =this.props.btn.requestMethod || 'get';

       if(url){
           //封装参数
           let requestParam = this.props.btn.requestParam || 'id';
           let requestParamValKey = this.props.btn.requestParamValKey || 'id';

           if (requestParam) {
               body[requestParam] = record[requestParamValKey];
           }
           let customRequestParam = this.props.btn.customRequestParam || 'status';
           let customRequestValue = this.props.btn.customRequestValue || '0';

           if (requestParam) {
               body[customRequestParam] = customRequestValue;
           }

           url=url+'/'+record[requestParamValKey]
           this.request({
               url,
               method,
               contentType:'json',
               body: body,
               callback: (data) => {
                   this.complete();
               }
           });
       }*/
       console.log(this.props.record);
        let title = this.props.btn.title;
       // '/cm-sites/pms/addContribute/addContributeNews.html?interviewId=0&attribute=original&actButtonId=30&isShowMainColumnSetBtn=false&eiditStoryId=4719'
       let url='/cm-sites/pms/addContribute/addContributeNews.html?attribute=original&actButtonId=30&isShowMainColumnSetBtn=false'//'copyType='+copyType+'&srcId='+item.id+'&actButtonId=2&fromZyk=true&currentMediaCode='+this.props.match.params.mediaCode;//1任务稿件，2，投稿稿件，3.其他稿件，
       if(this.props.btn.url) {
           url = this.props.btn.url;
           let params = this.props.btn.params;
           console.log(params,'paramsparamsparams')
           if(params && params.length) {
               params.forEach(item=>{
                   if(item['routeKey'] && item['routeValKey'] &&this.props.record&& this.props.record[item['routeValKey']]) {
                       let str = '&' + item['routeKey'] + '=' + (this.props.record&&this.props.record[item['routeValKey']]||'');
                       url += str;
                   }
               })
           }
       }
       let that = this;
       window.openFull(url, title, null, {
           shade: 0.5,
           area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
       }, null, function () {
           that.complete()
       })

   }

   btnOpen(){
       window.open('http://www.baidu.com')
   }

    btnOpenJumps() {
        console.log('----------------',this.props.record);
        let url='/writing/writing'// /writing/writing/8750/2/896  // eiditStoryId=8750&actButtonId=2&interviewId=896
        if(this.props.btn.url) {
            url = this.props.btn.url;
            let params = this.props.btn.params;
            if(params && params.length) {
                params.forEach(item=>{
                    if((item['routeValKey'] && this.props.record && this.props.record[item['routeValKey']]) || item['defaultVal']!==undefined) {
                        let str = '/' + (this.props.record && this.props.record[item['routeValKey']] || item['defaultVal']);
                        url += str;
                    }
                })
            }
        }
        window.location.hash = url;
    }

}